import toArray from '../_helpers/toarray.js';
import forEach from '../_helpers/foreach.js';
var listeners = new WeakMap();
var nonBubblingReg = /^(focus|blur|mouseenter|mouseleave|pointerenter|pointerleave|load|error|scroll|toggle|invalid)$/;
var scopeAttr = Math.random().toString().replace('0.', 'x') + "y"; // x12345y
// the parents rows, cells and options need where there is no <template> (from jQuery)
var wrapMap = {
  option: [1, '<select multiple="multiple">', '</select>'],
  legend: [1, '<fieldset>', '</fieldset>'],
  thead: [1, '<table>', '</table>'],
  tr: [2, '<table><tbody>', '</tbody></table>'],
  td: [3, '<table><tbody><tr>', '</tr></tbody></table>'],
  col: [2, '<table><colgroup>', '</colgroup></table>'],
  area: [1, '<map>', '</map>']
};
wrapMap.optgroup = wrapMap.option;
wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;
// the nodes of HTML; <template> parses rows, cells and options without wrapping them
export function parseHTML(givenHTML) {
  var html = givenHTML.trim();
  var template = document.createElement('template');
  if (template.content) {
    template.innerHTML = html;
    return toArray(template.content.childNodes);
  }
  var tag = /<([\w:]+)/.exec(html);
  var _ref = tag && wrapMap[tag[1].toLowerCase()] || [0, '', ''],
    depth = _ref[0],
    before = _ref[1],
    after = _ref[2];
  var node = document.createElement('div');
  node.innerHTML = before + html + after;
  for (var i = 0; i < depth; i++) node = node.children[0];
  return toArray(node.childNodes);
}
// nodes from a selector, HTML, a node, window or anything array-like (NodeList, jQuery, an array)
export function toNodes(input) {
  if (!input) return [];
  // window isn't a Node, but it is kept in the same list
  if (input.nodeType || typeof window !== 'undefined' && input === window) return [input];
  if (typeof input === 'string') {
    return /</.test(input) ? parseHTML(input) : toArray(document.querySelectorAll(input));
  }
  if (typeof input.length === 'number') return toArray(input);
  return [input];
}
// the nodes of every list once, in order
export function uniqueNodes() {
  var seen = new Set();
  var result = [];
  for (var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++) {
    lists[_key] = arguments[_key];
  }
  forEach(lists, function (list) {
    return forEach(list, function (node) {
      if (!seen.has(node)) {
        seen.add(node);
        result.push(node);
      }
    });
  });
  return result;
}
// Element#matches, msMatchesSelector on IE 11; false for a node that has neither (text, document, window)
export function matches(node, selector) {
  var method = node.matches || node.msMatchesSelector;
  return Boolean(method == null ? void 0 : method.call(node, selector));
}
// Element#closest, which IE 11 lacks
function closest(node, selector) {
  for (var current = node; current && current.nodeType === 1; current = current.parentNode) {
    if (matches(current, selector)) return current;
  }
  return null;
}
// the parts of a selector list, split at the commas outside brackets, parentheses and quotes
function splitSelectorList(selector) {
  var parts = [];
  var depth = 0;
  var quote = '';
  var start = 0;
  for (var i = 0; i < selector.length; i++) {
    var char = selector[i];
    if (quote) {
      if (char === '\\') i++;else if (char === quote) quote = '';
    } else if (char === '"' || char === "'") quote = char;else if (char === '\\') i++;else if (char === '(' || char === '[') depth++;else if (char === ')' || char === ']') depth--;else if (char === ',' && depth === 0) {
      parts.push(selector.slice(start, i));
      start = i + 1;
    }
  }
  parts.push(selector.slice(start));
  return parts;
}
// the delegated selector matches only inside the node the listener is on
function matchesInside(node, target, selector) {
  // document, a fragment or window can't take the scope attribute; everything is inside them
  if (!node.setAttribute) {
    var found = closest(target, selector);
    return Boolean(found && (!node.contains || node.contains(found)));
  }
  var scoped = splitSelectorList(selector).map(function (part) {
    return "[" + scopeAttr + "] " + part + ",[" + scopeAttr + "] " + part + " *";
  }).join(',');
  node.setAttribute(scopeAttr, '');
  try {
    return matches(target, scoped);
  } finally {
    node.removeAttribute(scopeAttr);
  }
}
// adds a listener once per node, name, selector and handler
export function listen(node, names, givenSelector, handler) {
  var selector = givenSelector || null;
  var list = listeners.get(node) || [];
  listeners.set(node, list);
  var _loop = function _loop() {
    var name = _names$split2[_i2];
    if (list.some(function (item) {
      return item.name === name && item.handler === handler && item.selector === selector;
    })) return 1; // continue
    // focus, blur, mouseenter and the like don't bubble, so a delegated listener catches them at capture phase
    var capture = Boolean(selector) && nonBubblingReg.test(name);
    var listener = selector ? function delegated(evt) {
      if (matchesInside(this, evt.target, selector)) handler.call(this, evt);
    } : handler;
    list.push({
      name: name,
      selector: selector,
      handler: handler,
      listener: listener,
      capture: capture
    });
    node.addEventListener(name, listener, capture);
  };
  for (var _i2 = 0, _names$split2 = names.split(/\s+/); _i2 < _names$split2.length; _i2++) {
    if (_loop()) continue;
  }
}
// removes what listen added
export function unlisten(node, names, givenSelector, handler) {
  var selector = givenSelector || null;
  var list = listeners.get(node);
  if (!list) return;
  for (var _i4 = 0, _names$split4 = names.split(/\s+/); _i4 < _names$split4.length; _i4++) {
    var name = _names$split4[_i4];
    for (var i = list.length - 1; i >= 0; i--) {
      var item = list[i];
      if (item.name === name && item.handler === handler && item.selector === selector) {
        node.removeEventListener(name, item.listener, item.capture);
        list.splice(i, 1);
      }
    }
  }
}